import React from 'react';
import {
  formatWarehouseNdcOrUpc,
  getWarehouseScheduleLabel,
  isControlledDeaSchedule,
  type WarehouseProductShape
} from '@/lib/utils/deaScheduleUtils';
import './WarehouseProductDisplay.scss';

export type WarehouseProductDisplayProps = {
  product: WarehouseProductShape | null | undefined;
  className?: string;
  /** Smaller type for dense headers (pick scan, etc.). */
  compact?: boolean;
  /** Optional first line (e.g. priority location) shown above the product name. */
  prefix?: React.ReactNode;
  /** Shown after the NDC / schedule row (e.g. short-dated banner). */
  children?: React.ReactNode;
};

function WarehouseProductDisplay({
  product,
  className = '',
  compact = false,
  prefix,
  children
}: WarehouseProductDisplayProps) {
  const title = product?.title?.trim() || 'Product';
  const idLine = formatWarehouseNdcOrUpc(product);
  const scheduleLabel = getWarehouseScheduleLabel(product);
  const controlled = isControlledDeaSchedule(product?.fdaProduct?.deaSchedule);

  const rootClass = [
    'warehouse-product-display',
    compact && 'warehouse-product-display--compact',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass}>
      {prefix != null && prefix !== false && prefix !== '' && (
        <div className="warehouse-product-display__prefix">{prefix}</div>
      )}
      <div className="warehouse-product-display__title">{title}</div>
      <div className="warehouse-product-display__identifier-row">
        <span
          className={[
            'warehouse-product-display__pill',
            controlled
              ? 'warehouse-product-display__pill--controlled'
              : 'warehouse-product-display__pill--neutral'
          ].join(' ')}
        >
          {scheduleLabel}
        </span>
        {idLine != null && (
          <span className="warehouse-product-display__identifier">{idLine}</span>
        )}
      </div>
      {children}
    </div>
  );
}

export default WarehouseProductDisplay;
